export const typography = {
  fontFamily: [
    'Manrope',
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    'Roboto',
    'Arial',
    'sans-serif'
  ].join(','),
  // Font weight variants
  thin: {
    fontWeight: 100,
  },
  extraLight: {
    fontWeight: 200,
  },
  light: {
    fontWeight: 300,
  },
  regular: {
    fontWeight: 400,
  },
  medium: {
    fontWeight: 500,
  },
  semiBold: {
    fontWeight: 600,
  },
  bold: {
    fontWeight: 700,
  },
  extraBold: {
    fontWeight: 800,
  },
  black: {
    fontWeight: 900,
  },
  // Heading variants
  h1: {
    fontFamily: 'Manrope',
    fontWeight: 700,
  },
  h2: {
    fontFamily: 'Manrope',
    fontWeight: 600,
  },
  h3: {
    fontFamily: 'Manrope',
    fontWeight: 700,
  },
  h4: {
    fontFamily: 'Manrope',
    fontWeight: 700,
  },
  h5: {
    fontFamily: 'Manrope',
    fontWeight: 700,
  },
  h6: {
    fontFamily: 'Manrope',
    fontWeight: 700,
  },
  // Body variants
  body1: {
    fontFamily: 'Manrope',
    fontWeight: 400,
  },
  body2: {
    fontFamily: 'Manrope',
    fontWeight: 400,
  },
  // Other variants
  button: {
    fontFamily: 'Manrope',
    fontWeight: 700,
    textTransform: 'none',
  },
  caption: {
    fontFamily: 'Manrope',
    fontWeight: 400,
  },
  subtitle1: {
    fontFamily: 'Manrope',
    fontWeight: 600,
  },
  subtitle2: {
    fontFamily: 'Manrope',
    fontWeight: 600,
  },
}
